import React from "react";
import LegalPageLayout from "../../components/common/LegalPageLayout";
import CookiePolicyData from "./CookiePolicyData";

const CookiePolicy = () => (
  <LegalPageLayout
    pageTitle="Cookie Policy"
    effectiveDate="May 2, 2026"
    sections={CookiePolicyData}
  />
);

export default CookiePolicy;
